import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class NotifyUserMoveToInsideVaultUpdate {
  private subject = new Subject<void | any>();

  sendMessage(message: boolean) {
    this.subject.next({ text: message });
  }

  clearMessages() {
    this.subject.next(null);
  }

  getMessage(): Observable<any> {
    return this.subject.asObservable();
  }
}
